/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { useCallback, useMemo, useState } from 'react';
import { FocusRestorationContext } from '../../controllers/focus-restoration-context.tsx';

// The idea of this component is to provide a focus restoration context for the project menu items.
// The context will be read deep down the tree where the menuItem which supports drag-and-drop is rendered.

export function ContentWithDragAndDrop({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element {
	const [shouldRestoreFocus, setShouldRestoreFocus] = useState<boolean>(false);

	const enableRestoreFocus = useCallback(() => {
		setShouldRestoreFocus(true);
	}, []);

	const clearRestoreFocus = useCallback(() => {
		setShouldRestoreFocus(false);
	}, []);

	const contextValue = useMemo(
		() => ({
			shouldRestoreFocus,
			enableRestoreFocus,
			clearRestoreFocus,
		}),
		[clearRestoreFocus, enableRestoreFocus, shouldRestoreFocus],
	);

	return (
		<FocusRestorationContext.Provider value={contextValue}>
			{children}
		</FocusRestorationContext.Provider>
	);
}
